import { Splide } from "@splidejs/splide";

const carousel = () => {
  const targetElms = document.getElementsByClassName('js-sliderLocation');
  if(targetElms.length === 0) return;
  
  for(const targetElm of targetElms) {
    const speed = 400;
    
    // 既に初期化済みかチェック
    if(targetElm.dataset.initialized === 'true') {
      continue;
    }
    
    let options = {
      type: "loop",
      speed: speed,
      rewindSpeed: speed,
      autoWidth: true,
      // gap: "0.5rem",
      arrows: true,
      pagination: true,
      rewind: true,
      breakpoints: {
        768: {
          drag: false,
          swipe: false,
        },
      },
      reduceMotion: {
        speed: speed,
        rewindSpeed: speed,
        autoplay: true,
      }
    }
    
    if(targetElm.dataset.speed) {
      options.speed = parseInt(targetElm.dataset.speed);
      options.rewindSpeed = parseInt(targetElm.dataset.speed);
      options.reduceMotion.speed = parseInt(targetElm.dataset.speed);
      options.reduceMotion.rewindSpeed = parseInt(targetElm.dataset.speed);
    }

    if(targetElm.dataset.gap) {
      options.gap = targetElm.dataset.gap;
    }

    const slider = new Splide(targetElm, options);
    
    // ===================================
    // カスタムページネーションの設定（複数対応）
    // ===================================
    const paginationIds = targetElm.dataset.pagination;
    if(paginationIds) {
      // デフォルトのページネーションを無効化
      options.pagination = false;
      // カンマで区切って配列に変換（前後の空白も除去）
      const paginationIdArray = paginationIds.split(',').map(id => id.trim());
      // すべてのカスタムページネーション要素を格納する配列
      const allCustomPaginations = [];
      
      // 各IDに対応するページネーション要素を取得
      paginationIdArray.forEach(paginationId => {
        const customPagination = document.getElementById(paginationId);
        if(customPagination) {
          allCustomPaginations.push(customPagination);

        }
      });
      
      // ページネーション要素が1つでも見つかった場合
      if(allCustomPaginations.length > 0) {
        // すべてのページネーションのボタンを格納する配列
        const allPaginationButtons = [];
        // 各ページネーション要素のボタンを取得してイベントを設定
        allCustomPaginations.forEach(customPagination => {
          const paginationButtons = customPagination.querySelectorAll('.js-pagination-item');
          
          if(paginationButtons.length > 0) {
            // 初期状態: 最初のボタンをアクティブに
            paginationButtons[0]?.classList.add('is-active');
            
            // 各ボタンにクリックイベントを追加
            paginationButtons.forEach((button, index) => {
              // 既存のイベントリスナーを削除するため、新しい要素に置き換える
              const newButton = button.cloneNode(true);
              button.parentNode.replaceChild(newButton, button);
              
              newButton.addEventListener('click', () => {
                slider.go(index);
              });
              
              // すべてのボタンの配列に追加
              allPaginationButtons.push(newButton);
            });
          }
        });
        
        // スライダーが移動を開始したときにすべてのページネーションのアクティブ状態を更新
        slider.on('move', (newIndex) => {
          // すべてのボタンからis-activeを削除
          allPaginationButtons.forEach(btn => {
            btn.classList.remove('is-active');
          });
          
          // 各ページネーションの対応するボタンにis-activeを追加
          allCustomPaginations.forEach(customPagination => {
            const buttons = customPagination.querySelectorAll('.js-pagination-item');
            if(buttons[newIndex]) {
              buttons[newIndex].classList.add('is-active');
            }
          });
        });
        
        // マウント時にもアクティブ状態を確認
        slider.on('mounted', () => {
          const currentIndex = slider.index;
          
          allCustomPaginations.forEach(customPagination => {
            const buttons = customPagination.querySelectorAll('.js-pagination-item');
            buttons.forEach((btn, index) => {
              if(index === currentIndex) {
                btn.classList.add('is-active');
              } else {
                btn.classList.remove('is-active');
              }
            });
          });
        });
      }
    }
    
    slider.mount();
    
    // 初期化済みマークを付ける
    targetElm.dataset.initialized = 'true';
  }
}

const init = () => {
  carousel();
}

export default init;